import { iPermission, PermissionsActionTypes, SET_PERMISSIONS } from "./types"

const initialState: Array<iPermission> = []

export function permissionsReducer(
  state: Array<iPermission> = initialState,
  action: PermissionsActionTypes,
): Array<iPermission> {
  switch (action.type) {
    case SET_PERMISSIONS:
      return action.payload
    default:
      return state
  }
}
